export const DOWNLOAD_B1_FORM = gql`
    mutation downloadB1Form($id: Int!) {
        downloadB1Form(id: $id) {
            id
            fileName
            url
        }
    }
`;

export const DOWNLOAD_PARTNERSHIP_DEED_FILE = gql`
    mutation DownloadPartnershipDeedFile($id: Int!) {
        downloadPartnershipDeedFile(id: $id) {
            id
            fileName
            url
        }
    }
`;
